<template>
  <div class="partner-pregled forma-erp">

    <!-- Zaglavlje: naziv, OIB i oznake. Brisanje je kanta lijevo od uredjivanja,
         odmaknuta da se ne klikne slucajno. -->
    <div class="traka-partner">
      <v-icon class="ikona" color="white">{{ partner.privatePerson ? 'mdi-account' : 'mdi-domain' }}</v-icon>
      <div class="opis">
        <div class="naslov">{{ partner.partnerName }}</div>
        <div class="pod">
          <span class="znak" v-if="partner.partnerVATID">{{ bezZvjezdice(lang.PartnerVATID) }} {{ partner.partnerVATID }}</span>
          <span class="znak" v-if="partner.partnerNameShort">{{ partner.partnerNameShort }}</span>
          <span class="znak osoba" v-if="partner.privatePerson">{{ lang.PartnerPrivate }}</span>
          <span class="znak poseban" v-if="partner.specialCustomer">{{ lang.specialCustomer }}</span>
          <span class="znak neaktivan" v-if="partner.Activ === false">{{ lang.PartnerNotActiv }}</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="razinaPristupa === 1"
        icon
        dark
        class="mr-6"
        :title="langC.Delete"
        @click="partnerDelete"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
      <v-btn v-if="razinaPristupa <= 3" small class="white primary--text mr-2" @click="partnerEdit">
        {{ langC.Edit }}
      </v-btn>
      <v-btn small class="green white--text" @click="partnerlist">{{ langC.Back }}</v-btn>
    </div>

    <!-- Ono zbog cega se partner najcesce otvara. -->
    <div class="brojke">
      <div class="stavka">
        <span>{{ lang.PartnerAddress }}</span>
        <b>{{ adresaKratko }}</b>
      </div>
      <div class="crta"></div>
      <div class="stavka">
        <span>{{ lang.Partneremail }}</span>
        <b>{{ partner.partneremail ? partner.partneremail : '—' }}</b>
      </div>
      <div class="crta"></div>
      <div class="stavka">
        <span>{{ lang.PartnerPhones }}</span>
        <b>{{ partner.partnerPhones ? partner.partnerPhones : '—' }}</b>
      </div>
      <div class="crta"></div>
      <div class="stavka">
        <span>{{ lang.PartnerBankIBAN }}</span>
        <b>{{ partner.partnerBankIBAN ? partner.partnerBankIBAN : '—' }}</b>
      </div>
      <v-spacer></v-spacer>
      <v-checkbox v-model="svaPolja" :label="lang.PartnerShowAllFields" hide-details dense class="mt-0 pt-0"></v-checkbox>
    </div>

    <v-row no-gutters>
      <!-- ---------- lijevo: tko je partner ---------- -->
      <v-col cols="12" md="6" class="pr-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">{{ lang.BasicData }}</v-card-title>
          <v-card-text class="tijelo">
            <div class="polja">
              <template v-for="polje in osnovniPodaci">
                <div class="naziv" :key="polje.kljuc + '-n'" v-if="polje.vrijednost || svaPolja">{{ polje.naziv }}</div>
                <div class="vrijednost" :key="polje.kljuc + '-v'" v-if="polje.vrijednost || svaPolja">
                  <span v-if="polje.vrijednost">{{ polje.vrijednost }}</span>
                  <span v-if="!polje.vrijednost" class="prazno">—</span>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="direktorOtvoren = !direktorOtvoren">
            {{ lang.PartnerCEO }}
            <span class="dodatak" v-if="!imaDirektora">{{ lang.PartnerEmptyCard }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ (direktorOtvoren || svaPolja) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="direktorOtvoren || svaPolja">
            <div class="polja">
              <template v-for="polje in direktor">
                <div class="naziv" :key="polje.kljuc + '-n'">{{ polje.naziv }}</div>
                <div class="vrijednost" :key="polje.kljuc + '-v'">
                  <span v-if="polje.vrijednost">{{ polje.vrijednost }}</span>
                  <span v-if="!polje.vrijednost" class="prazno">—</span>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="tajnicaOtvorena = !tajnicaOtvorena">
            {{ lang.PartnerSecretary }}
            <span class="dodatak" v-if="!imaTajnicu">{{ lang.PartnerEmptyCard }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ (tajnicaOtvorena || svaPolja) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="tajnicaOtvorena || svaPolja">
            <div class="polja">
              <template v-for="polje in tajnica">
                <div class="naziv" :key="polje.kljuc + '-n'">{{ polje.naziv }}</div>
                <div class="vrijednost" :key="polje.kljuc + '-v'">
                  <span v-if="polje.vrijednost">{{ polje.vrijednost }}</span>
                  <span v-if="!polje.vrijednost" class="prazno">—</span>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ---------- desno: kako se s njim posluje ---------- -->
      <v-col cols="12" md="6" class="pl-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="bankaOtvorena = !bankaOtvorena">
            {{ lang.PartnerBank }}
            <span class="dodatak" v-if="!imaBanku">{{ lang.PartnerEmptyCard }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ (bankaOtvorena || imaBanku || svaPolja) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="bankaOtvorena || imaBanku || svaPolja">
            <div class="polja">
              <template v-for="polje in banka">
                <div class="naziv" :key="polje.kljuc + '-n'" v-if="polje.vrijednost || svaPolja">{{ polje.naziv }}</div>
                <div class="vrijednost" :key="polje.kljuc + '-v'" v-if="polje.vrijednost || svaPolja">
                  <span v-if="polje.vrijednost">{{ polje.vrijednost }}</span>
                  <span v-if="!polje.vrijednost" class="prazno">—</span>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="postavkeOtvorene = !postavkeOtvorene">
            {{ lang.PartnerSettings }}
            <span class="dodatak">{{ lang.PartnerSettingsHint }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ (postavkeOtvorene || svaPolja) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="postavkeOtvorene || svaPolja">
            <div class="polja">
              <template v-for="polje in postavke">
                <div class="naziv" :key="polje.kljuc + '-n'">{{ polje.naziv }}</div>
                <div class="vrijednost" :key="polje.kljuc + '-v'">
                  <span v-if="polje.vrijednost">{{ polje.vrijednost }}</span>
                  <span v-if="!polje.vrijednost" class="prazno">—</span>
                </div>
              </template>
            </div>
            <div class="podnaslov mt-4">{{ lang.PartnerFlags }}</div>
            <div class="oznake">{{ oznake }}</div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="tekstoviOtvoreni = !tekstoviOtvoreni">
            {{ lang.PartnerTexts }}
            <span class="dodatak" v-if="!imaTekstove">{{ lang.PartnerEmptyCard }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ (tekstoviOtvoreni || svaPolja) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="tekstoviOtvoreni || svaPolja">
            <div class="polja">
              <template v-for="polje in tekstovi">
                <div class="naziv" :key="polje.kljuc + '-n'">{{ polje.naziv }}</div>
                <div class="vrijednost" :key="polje.kljuc + '-v'">
                  <span v-if="polje.vrijednost">{{ polje.vrijednost }}</span>
                  <span v-if="!polje.vrijednost" class="prazno">—</span>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">{{ lang.PartnerRecord }}</v-card-title>
          <v-card-text class="tijelo">
            <div class="polja">
              <div class="naziv">{{ lang.PartnerLastUpdateBy }}</div>
              <div class="vrijednost">
                <span v-if="partner.LastUpdateBy">{{ partner.LastUpdateBy }}</span>
                <span v-if="!partner.LastUpdateBy" class="prazno">—</span>
              </div>
              <div class="naziv">{{ lang.PartnerLastUpdate }}</div>
              <div class="vrijednost">
                <span v-if="partner.LastUpdate">{{ datum(partner.LastUpdate) }}</span>
                <span v-if="!partner.LastUpdate" class="prazno">—</span>
              </div>
              <div class="naziv">Db id</div>
              <div class="vrijednost">{{ partner.id }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PartnerService from '@/services/PartnerService'
import langEn from './PartnerDescEN'
import langHr from './PartnerDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'

export default {
  name: 'partnerview',
  data () {
    return {
      svaPolja: false,
      direktorOtvoren: false,
      tajnicaOtvorena: false,
      postavkeOtvorene: false,
      bankaOtvorena: false,
      tekstoviOtvoreni: false,
      msg: '',
      partner: {},
      locStartFrom: '',
      locCreatedAt: '',
      locUpdatedAt: '',
      locLastLogin: '',
      locForgotDate: '',
      haveRight: 4,
      error: '',
      lang: {},
      langC: {},
      privateP: true,
      admin: false,
      adress1: '',
      adress2: '',
      adress3: '',
      adress4: '',
      adress5: '',
      adress6: '',
      bank: '',
      director: '',
      directorBorn: '',
      contact: '',
      contactBorn: ''
    }
  },
  async mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    if (this.$store.state.user.Admin) {
        this.admin = this.$store.state.user.Admin
      }
    this.privateP = this.$store.state.user ? this.$store.state.user.privatePartner : true

      const query = {}
      query.partnerVATID = this.$store.state.partnerVATID ? this.$store.state.partnerVATID.toString() : null
      try {
        const dbPartner = await PartnerService.show(
          this.$store.state.partnerVATID.toString()
        )
        console.log('dbPartner ', dbPartner)
        this.partner = dbPartner && dbPartner.data && dbPartner.data.partner ?  dbPartner.data.partner: {}
        this.locStartFrom = dayjs(this.partner.StartFrom).format(
          'DD.MM.YYYY'
        )
        this.locCreatedAt = dayjs(this.partner.createdAt).format(
          'DD.MM.YYYY HH:mm'
        )
        this.locUpdatedAt = dayjs(this.partner.updatedAt).format(
          'DD.MM.YYYY HH:mm'
        )
      } catch (error) {
        this.error = error
      }
    

    this.bank = (this.partner.partnerBankName ? this.partner.partnerBankName : '') + (this.partner.partnerBankAddress ? ', ' + this.partner.partnerBankAddress : '')
    this.adress1 = (this.partner.partnerStreet ? this.partner.partnerStreet : '') + ' ' + (this.partner.partnerBuildingNameNumber ? this.partner.partnerBuildingNameNumber : '')
    this.adress2 = (this.partner.partnerPostcode ? this.partner.partnerPostcode : '') + ' ' + (this.partner.partnerCity ? this.partner.partnerCity : '') + (this.partner.partnerCountyRegion ? ', ' + this.partner.partnerCountyRegion : '') + (this.partner.partnerState ? ', ' + this.partner.partnerState : '') 

    this.director = (this.partner.partnerDirectorTitle ? this.partner.partnerDirectorTitle : '') + ' ' + (this.partner.partnerDirectorFirst ? this.partner.partnerDirectorFirst : '') + ' ' + (this.partner.partnerDirectorLast ? this.partner.partnerDirectorLast : '') + ' ' + (this.partner.partnerDirectorFormer ? this.partner.partnerDirectorFormer : '')
    this.directorBorn = (this.partner.partnerDirectorDateOfBirth ? this.partner.partnerDirectorDateOfBirth : '') + (this.partner.PartnerDirectorNationality ? ', ' + this.partner.PartnerDirectorNationality : '')
    this.adress3 = (this.partner.partnerDirectorAdressStreet ? this.partner.partnerDirectorAdressStreet : '') + ' ' + (this.partner.partnerDirectorAdressBuildingNameNumber ? this.partner.partnerDirectorAdressBuildingNameNumber : '')
    this.adress4 = (this.partner.partnerDirectorPostcode ? this.partner.partnerDirectorPostcode : '') + ' ' + (this.partner.partnerDirectorCity ? this.partner.partnerDirectorCity : '') + (this.partner.partnerDirectorCountyRegion ? ', ' + this.partner.partnerDirectorCountyRegion : '')+ (this.partner.partnerDirectorStateResidence ? ', ' + this.partner.partnerDirectorStateResidence : '') 

    this.contact = (this.partner.partneSecretaryTitle ? this.partner.partneSecretaryTitle : '') + ' ' + (this.partner.partneSecretaryFirst ? this.partner.partneSecretaryFirst : '') + ' ' + (this.partner.partneSecretaryLast ? this.partner.partneSecretaryLast : '') + ' ' + (this.partner.partneSecretaryFormer ? this.partner.partneSecretaryFormer : '')
    this.contactBorn = (this.partner.partnerSecretaryDateOfBirth ? this.partner.partnerSecretaryDateOfBirth : '') + (this.partner.PartnerSecretaryNationality ? ', ' + this.partner.PartnerSecretaryNationality : '')
    this.adress5 = (this.partner.partnerSecretaryAdressStreet ? this.partner.partnerSecretaryAdressStreet : '') + ' ' + (this.partner.partnerSecretaryAdressBuildingNameNumber ? this.partner.partnerSecretaryAdressBuildingNameNumber : '')
    this.adress6 = (this.partner.partnerSecretaryPostcode ? this.partner.partnerSecretaryPostcode : '') + ' ' + (this.partner.partnerSecretaryCity ? this.partner.partnerSecretaryCity : '') + (this.partner.partnerSecretaryCountyRegion ? ', ' + this.partner.partnerSecretaryCountyRegion : '')+ (this.partner.partnerSecretaryStateResidence ? ', ' + this.partner.partnerSecretaryStateResidence : '')

  },
  methods: {
    pNum (vrijednost) { return parseFloat(vrijednost) || 0 },
    tekst (vrijednost) {
      return vrijednost === null || vrijednost === undefined ? '' : String(vrijednost).trim()
    },
    // Nula na ovim poljima znaci "nije upisano".
    broj (vrijednost) {
      const n = this.pNum(vrijednost)
      return n === 0 ? '' : String(vrijednost).trim()
    },
    // Nazivi u obrascu nose zvjezdicu za obavezno polje; u pregledu smeta.
    bezZvjezdice (naziv) {
      return String(naziv || '').replace(/\s*\*\s*$/, '')
    },
    datum (vrijednost) {
      return vrijednost ? dayjs(vrijednost).format('DD.MM.YYYY') : ''
    },

    async partnerlist () {
      try {
        await this.$router.push({
          name: 'partner'
        })
      } catch (err) {
        this.error = err
      }
    },
    async partnerDelete () {
      try {
        await this.$router.push({
          name: 'partnerdelete'
        })
      } catch (error) {
        this.error = error
      }
    },
    async partnerEdit () {
      try {
        this.$store.dispatch('seteditItem', 1)
        await this.$router.push({
          name: 'partnercreate'
        })
      } catch (error) {
        this.error = error
      }
    }
  },
  computed: {
    // Kad sesija istekne, "user" u storeu je null - prikaz to ne smije srusiti.
    // Razina iz baze stize kao tekst ("1.00"), pa mora u broj.
    razinaPristupa () {
      const u = this.$store.state.user
      return u && u.AccessLevel !== undefined ? (parseFloat(u.AccessLevel) || 9) : 9
    },
    adresaKratko () {
      const u = this.tekst(this.partner.partnerStreet)
      const br = this.tekst(this.partner.partnerBuildingNameNumber)
      const pb = this.tekst(this.partner.partnerPostcode)
      const g = this.tekst(this.partner.partnerCity)
      // Kucni broj i postanski broj znaju vec biti u ulici odnosno gradu.
      const ulica = br && u.split(/\s+/).indexOf(br) === -1 ? (u + ' ' + br).trim() : u
      const grad = pb && g.indexOf(pb) === -1 ? (pb + ' ' + g).trim() : g
      const spojeno = [ulica, grad].filter(x => x).join(', ')
      return spojeno || '—'
    },
    osnovniPodaci () {
      return [
        { kljuc: 'partnerName', naziv: this.bezZvjezdice(this.lang.PartnerName), vrijednost: this.tekst(this.partner.partnerName) },
        { kljuc: 'partnerNameShort', naziv: this.bezZvjezdice(this.lang.PartnerNameShort), vrijednost: this.tekst(this.partner.partnerNameShort) },
        { kljuc: 'partnerVATID', naziv: this.bezZvjezdice(this.lang.PartnerVATID), vrijednost: this.tekst(this.partner.partnerVATID) },
        { kljuc: 'adresa1', naziv: this.lang.PartnerAdress1, vrijednost: this.adresaKratko === '—' ? '' : this.adresaKratko },
        { kljuc: 'partnerState', naziv: this.lang.PartnerStateLabel, vrijednost: this.tekst(this.partner.partnerState) },
        { kljuc: 'partnerCountyRegion', naziv: this.lang.PartnerCountyRegion, vrijednost: this.tekst(this.partner.partnerCountyRegion) },
        { kljuc: 'partneremail', naziv: this.lang.Partneremail, vrijednost: this.tekst(this.partner.partneremail) },
        { kljuc: 'partnerPhones', naziv: this.lang.PartnerPhones, vrijednost: this.tekst(this.partner.partnerPhones) },
        { kljuc: 'partnerType', naziv: this.lang.PartnerType, vrijednost: this.tekst(this.partner.partnerType) }
      ]
    },
    banka () {
      return [
        { kljuc: 'partnerBankIBAN', naziv: this.lang.PartnerBankIBAN, vrijednost: this.tekst(this.partner.partnerBankIBAN) },
        { kljuc: 'partnerBankName', naziv: this.lang.PartnerBankName, vrijednost: this.tekst(this.partner.partnerBankName) },
        { kljuc: 'partnerBankAddress', naziv: this.lang.PartnerBankAddress, vrijednost: this.tekst(this.partner.partnerBankAddress) },
        { kljuc: 'partnerBankSWIFT', naziv: this.lang.PartnerBankSWIFT, vrijednost: this.tekst(this.partner.partnerBankSWIFT) }
      ]
    },
    direktor () {
      return [
        { kljuc: 'ime', naziv: this.lang.PartnerCEO, vrijednost: [this.tekst(this.partner.partnerDirectorFirst), this.tekst(this.partner.partnerDirectorLast)].filter(x => x).join(' ') },
        { kljuc: 'zvanje', naziv: this.lang.PartnerDirectorBusinessOccupation, vrijednost: this.tekst(this.partner.partnerDirectorBusinessOccupation) },
        { kljuc: 'email', naziv: this.lang.PartnerDirectorEmail, vrijednost: this.tekst(this.partner.partnerDirectorEmail) },
        { kljuc: 'tel', naziv: this.lang.PartnerDirectorPhone, vrijednost: this.tekst(this.partner.partnerDirectorPhone) }
      ]
    },
    tajnica () {
      return [
        { kljuc: 'ime', naziv: this.lang.PartnerSecretary, vrijednost: [this.tekst(this.partner.partnerSecretaryFirst), this.tekst(this.partner.partnerSecretaryLast)].filter(x => x).join(' ') },
        { kljuc: 'email', naziv: this.lang.PartnerSecretaryEmail, vrijednost: this.tekst(this.partner.partnerSecretaryEmail) },
        { kljuc: 'tel', naziv: this.lang.PartnerSecretaryPhone, vrijednost: this.tekst(this.partner.partnerSecretaryPhone) }
      ]
    },
    postavke () {
      return [
        { kljuc: 'dana', naziv: this.lang.PartnerInvoiceDefDays, vrijednost: this.broj(this.partner.partnerInvoiceDefDays) },
        { kljuc: 'mjesto', naziv: this.lang.PartnerInvoicePlace, vrijednost: this.tekst(this.partner.partnerInvoicePlace) },
        { kljuc: 'vrsta', naziv: this.lang.PartnerInvoiceType, vrijednost: this.tekst(this.partner.partnerInvoiceType) },
        { kljuc: 'skladiste', naziv: this.lang.PartnerDefaultWarehouse, vrijednost: this.broj(this.partner.partnerDefaultWarehouse) },
        { kljuc: 'pisac', naziv: this.lang.PartnerPrinterSize, vrijednost: this.broj(this.partner.partnerPrinterSize) },
        { kljuc: 'brRacuna', naziv: this.lang.PartnerStartInvoiceNumber, vrijednost: this.broj(this.partner.partnerStartInvoiceNumber) },
        { kljuc: 'brBillova', naziv: this.lang.PartnerStartBillNumber, vrijednost: this.broj(this.partner.partnerStartBillNumber) }
      ]
    },
    tekstovi () {
      return [
        { kljuc: 'racun', naziv: this.lang.PartnerInvoiceMemo, vrijednost: this.tekst(this.partner.partnerInvoiceMemo) },
        { kljuc: 'racunIno', naziv: this.lang.PartnerInvoiceForeginMemo, vrijednost: this.tekst(this.partner.partnerInvoiceForeginMemo) },
        { kljuc: 'otpremnica', naziv: this.lang.PartnerDeliveryNoteMemo, vrijednost: this.tekst(this.partner.partnerDeliveryNoteMemo) },
        { kljuc: 'otpremnicaIno', naziv: this.lang.PartnerDeliveryNoteForeginMemo, vrijednost: this.tekst(this.partner.partnerDeliveryNoteForeginMemo) },
        { kljuc: 'napomena', naziv: this.lang.PartnerInvoiceHint, vrijednost: this.tekst(this.partner.partnerInvoiceHint) }
      ]
    },
    imaBanku () { return this.banka.some(x => x.vrijednost) },
    imaDirektora () { return this.direktor.some(x => x.vrijednost) },
    imaTajnicu () { return this.tajnica.some(x => x.vrijednost) },
    imaTekstove () { return this.tekstovi.some(x => x.vrijednost) },
    oznake () {
      const popis = []
      if (this.partner.privatePerson) { popis.push(this.lang.PartnerPrivate) }
      if (this.partner.specialCustomer) { popis.push(this.lang.specialCustomer) }
      if (this.partner.partnerVATonPay) { popis.push(this.lang.PartnerVATonPay) }
      if (this.partner.partnerRetail) { popis.push(this.lang.PartnerRetail) }
      if (this.partner.partnerUseRetailPrice) { popis.push(this.lang.PartnerUseRetailPrice) }
      if (this.partner.partnerShowWarehouseState) { popis.push(this.lang.PartnerShowWarehouseState) }
      if (this.partner.partnerShowInputPrice) { popis.push(this.lang.PartnerShowInputPrice) }
      if (this.partner.partnerShowLastSaleBuyer) { popis.push(this.lang.PartnerShowLastSaleBuyer) }
      return popis.length ? popis.join(' · ') : '—'
    },
},
  watch: {},
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.partner-pregled { padding: 8px 12px; }

.partner-pregled .traka-partner {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #1976d2;
  color: #fff;
  border-radius: 4px;
  padding: 10px 14px;
  margin-bottom: 12px;
}
.partner-pregled .traka-partner .ikona {
  font-size: 40px;
  opacity: 0.85;
}
.partner-pregled .traka-partner .naslov {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.partner-pregled .traka-partner .pod {
  margin-top: 3px;
}
.partner-pregled .znak {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 10px;
  padding: 1px 9px;
  margin-right: 5px;
}
.partner-pregled .znak.osoba {
  background: #90caf9;
  color: rgba(0, 0, 0, 0.87);
}
.partner-pregled .znak.poseban {
  background: #ffb300;
  color: rgba(0, 0, 0, 0.87);
}
.partner-pregled .znak.neaktivan {
  background: #c62828;
}

.partner-pregled .brojke {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 22px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 8px 16px;
  margin-bottom: 12px;
}
.partner-pregled .brojke .stavka span {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
}
.partner-pregled .brojke .stavka b {
  font-size: 15px;
}
.partner-pregled .brojke .crta {
  width: 1px;
  align-self: stretch;
  background: rgba(0, 0, 0, 0.12);
}

.partner-pregled .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 16px;
  min-height: 0;
  gap: 8px;
}
.partner-pregled .naslov-kartice .dodatak {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.partner-pregled .naslov-kartice.sklopiva {
  cursor: pointer;
}
.partner-pregled .tijelo {
  padding: 10px 16px 14px;
  color: rgba(0, 0, 0, 0.87);
}
.partner-pregled .polja {
  display: grid;
  grid-template-columns: 180px 1fr;
  row-gap: 7px;
  column-gap: 10px;
}
.partner-pregled .polja .naziv {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}
.partner-pregled .polja .vrijednost {
  font-weight: 500;
  word-break: break-word;
}
.partner-pregled .prazno {
  color: #cfd8dc;
  font-weight: 400;
}
.partner-pregled .podnaslov {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.75);
}
.partner-pregled .oznake {
  color: rgba(0, 0, 0, 0.6);
}
</style>
